import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { HelpCircle } from "lucide-react";

export default function FAQ() {
  const faqs = [
    {
      question: "How do I make a contribution?",
      answer: "Navigate to 'Savings & Contributions' → 'Record Contribution', enter the amount and payment method, then submit."
    },
    {
      question: "How can I request a loan?",
      answer: "Go to 'Loans & Payments' → 'New Loan Request', fill out the application form, and wait for approval from group leaders."
    },
    {
      question: "What is the minimum contribution amount?",
      answer: "The minimum contribution is RWF 10,000 per month, but you can contribute more based on your financial capacity."
    },
    {
      question: "How long does loan approval take?",
      answer: "Loan applications are typically reviewed within 2-3 business days by the group leadership committee."
    },
    {
      question: "Can I view my contribution history?",
      answer: "Yes, go to 'Savings & Contributions' → 'Contribution History' to view all your past contributions."
    },
    {
      question: "How do I update my profile?",
      answer: "Navigate to 'System Settings' → 'Account Settings' to update your personal information and preferences."
    }
  ];

  return (
    <div className="space-y-6 p-6">
      {/* Header Section */}
      <div className="flex items-center justify-between">
        <div className="space-y-1">
          <h1 className="text-3xl font-bold tracking-tight" style={{ color: '#050500' }}>
            Frequently Asked Questions
          </h1>
          <p style={{ color: '#050500', opacity: 0.7 }}>
            Find answers to common questions about the Saving Group system
          </p>
        </div>
      </div>

      {/* FAQ List */}
      <div className="space-y-4">
        {faqs.map((faq, index) => (
          <Card key={index}>
            <CardHeader>
              <CardTitle className="flex items-start space-x-3">
                <HelpCircle className="h-5 w-5 mt-1 text-blue-500" />
                <span className="text-lg">{faq.question}</span>
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-gray-600 leading-relaxed">{faq.answer}</p>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Contact Support */}
      <Card>
        <CardHeader>
          <CardTitle>Still Need Help?</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-gray-600 mb-4">
            If you couldn't find the answer to your question, please contact our support team.
          </p>
          <div className="flex space-x-4">
            <div className="text-sm">
              <p className="font-medium">Email Support</p>
              <p className="text-gray-500">caisse.iprcwest@gmail.com</p>
            </div>
            <div className="text-sm">
              <p className="font-medium">Phone Support</p>
              <p className="text-gray-500">0793502827</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
